import { lazyWithPreload } from "utils/lazyWithPreload"
import { universalRoutes } from "./universal"

const LiveWagons = lazyWithPreload(() => import("pages/wagon/LiveWagons"))
const WagonDetail = lazyWithPreload(() => import("pages/wagon/WagonDetail"))

export const wagonRoutes = [
  {
    path: "/",
    component: LiveWagons,
    meta: { breadcrumb: [{ parent: "Dashboard", label: "Live Wagons" }] },
  },
  {
    path: "/wagons/:wagonId",
    component: WagonDetail,
    meta: { breadcrumb: [{ parent: "Dashboard", label: "Wagon Detail" }] },
  },
  ...universalRoutes,
]
